import { Card } from "@dawa/ui";
import Footer from "../components/Footer";
import { features } from "../data/features";

export default function Features() {
  return (
    <div className="flex min-h-screen flex-col">
      <main className="flex-1 p-6">
        <h1 className="mb-6 text-2xl font-bold">Fonctionnalités</h1>
        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
          {features.map((f) => (
            <Card key={f.title} className="p-6 text-center">
              <f.icon className="mx-auto h-8 w-8 text-accent" />
              <h3 className="mt-4 text-lg font-semibold">{f.title}</h3>
              <p className="mt-2 text-sm text-muted">{f.description}</p>
            </Card>
          ))}
        </div>
      </main>
      <Footer />
    </div>
  );
}
